module.exports = __webpack_public_path__ + "static/media/asian-catfish.e73bfd18.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/asian-catfish.png
// module id = 294
// module chunks = 0